<template>
  <div class="case-box">
    <div class="bgPic" id="topBox">
      <div class="picText">
         <p class="title">解 决 方 案</p><br>
        <span>
          作为一支互联网IT团队，我们沉淀10余年的行业以及项目经验，针对性服务品牌<br>
          及企业，提供强有力的支持，深度解决行业需求，帮助企业增加实际收益。
        </span>
      </div>
    </div>

    <!-- ..................... -->
    <div class="middle" id="case1">
      <div class="five">
        <div class="left">
          <h2>强大的全渠道数字化信息平台</h2>
          <p>全渠道 数字化运营</p>
          <p>共享 可视 联动</p>
        </div>
        <div class="right">
          <img
            src="../assets/last/certificate/强大的全渠道数字化信息平台.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="middle bgc" id="case2">
      <div class="four">
        <div class="left">
          <img
            src="../assets/last/certificate/高效低本的AISM智能供应协同.png"
            alt=""
            style="height: 97%;"
          />
        </div>
        <div class="right">
          <h2>高效低本的AISM智能供应协同管理方案</h2>
          <p>
            AISM:建立与供应商基于线上化 进行协同式采购作业管理与供应
            商之间建立快速沟通机制，实现 协同流程化、透明化、规范化
          </p>
        </div>
      </div>
    </div>
   <div class="middle">
      <div class="five">
        <div class="left">
          <h2>数字化运营方案服务商</h2>
          <p>高效低本的AISM智能供应协同 管理方案</p>
        </div>
        <div class="right">
          <img
            src="../assets/last/certificate/数字化运营方案服务商图片.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="middle bgc"  id="case1"> 
      <div class="four ">
        <div class="left">
          <img src="../assets/last/certificate/智能客服图片.png"  alt="" />
        </div>
        <div class="right">
          <h2>高人效智能客服管理方案</h2>
          <p>
            更高效的帮用户解决售前、售后等各类问题，
            提升用户体验感，提高用户满意度，
            <span
              >智能机器人与人工结合，为用户提供专业、人性化、高效率的服务</span
            >
          </p>
          <div class="list-bit">
            <p>1) 24/7全天服务</p>
            <p>2）微信公众号、小程序、H5、APP多端接待客户</p>
            <p>3）语义精准识别，独立解决客户问题</p>
          </div>
        </div>
      </div>
    </div>

    <div class="middle"  id="case3">
      <div class="five">
        <div class="left">
          <h2>AICM数字化智能会员营销方案</h2>
          <p>数据决策与赋能</p>
        </div>
        <div class="right">
          <img
            src="../assets/last/certificate/AICM数字化智能会员营销方案.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="middle bgc">
      <div class="four">
        <div class="left">
          <img src="../assets/last/certificate/AICM会员系统.png" alt="" style="height: 80%;"/>
        </div>
        <div class="right">
          <h2>AICM数字化智能会员营销方案</h2>
          <p style="text-align: right;">数字化产品解决方案</p>
        </div>
      </div>
    </div>
    <div class="middle"  id="case4">
      <div class="five">
        <div class="left" style=" width: 600px;">
          <h2>AIAM人脸识别终端考勤解决方案</h2>
          <p>上千家门店，5000多名员工，跨门店打卡</p>
          <p>人脸识别，活体检测</p>
          <p>绑定门店设备</p>
          <p>异常打卡状态检测</p>

        </div>
        <div class="right">
          <img
            src="../assets/last/AIAM/大图.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- <div class="footer"></div> -->
     <BottomFooter />

  </div>
</template>

<script>
import BottomFooter from './bottom.vue'
export default {
  name: "Case",
  components: {
    BottomFooter
  },
  props: {
    point: {
      type:String,
      default:''
    }
  },
  data() {
    return {
      bannerHeight: 500,
      imgsArr: [
        {
          imgs: require("../assets/last/bg/数字化营销服务商背景.png"),
        },
        { imgs: require("../assets/last/bg/新闻资讯banner.png") },
        { imgs: require("../assets/last/bg/优秀案例背景.png") },
        { imgs: require("../assets/last/bg/解决方案背景.png") },
        { imgs: require("../assets/last/bg/关于我们背景.png") },
      ],
    };
  },
  watch: {
    point: {
      handler(news) {
          if(news){
        this.getScoll(news)
            console.log('新新新',news);
          }
      },
      immediate: true
    }
  },
  mounted() {},
created() {
},
  methods: {
    // 滚动
    getScoll(point){
      this.$nextTick(() => {
        // 元素自身高度
        const height = document.getElementById(point).offsetHeight
        const scrollTop = (document.getElementById(point).offsetTop)-(height/2) // 获取需要滚动的距离
        document.documentElement.scrollTop = scrollTop 
      })
    }
  },
};
</script>

<style lang="less" scoped>

.bgPic {
  background: url("../assets/last/bg/关于我们背景.png") no-repeat;
  background-size: cover;
  height: 75vh;
  min-height: 800px !important;
  position: relative;
//   height: 870px;
}
.picText {
  color: rgb(242, 243, 247);
  text-align: center;
  letter-spacing: 3px;
  line-height: 50px;
  font-family: SourceHanSansCN-Regular-;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-80%);
  
//   padding-top: 250px;
  .title {
    display: inline-block;
    font-size: 50px;
    font-weight: normal;
    letter-spacing: 7px;
  }
  span {
    font-size: 20px;
  }
  :hover{
      color: rgba(110, 87, 229);
    }
}
.middle {
  width: 100%;
  margin: auto;
  margin-top: 50px;
  padding-bottom: 100px;
  text-align: center;
}
.bgc{background-color: rgb(248, 248, 248);}
.four {
  width: 65%;
  padding-top: 100px;
  margin: auto;
  display: flex;
  justify-content:center;
  text-align: center;
  .left {
    width: 700px;
    img {
      height: 95%;
      width:110%;
    }
  }
  .right {
    margin-left:100px;
    width: 550px;
    font-size: 22px;
    // padding-top: 20px;
    text-align: left;
    line-height: 40px;
    color: #666666;
    h2 {
      white-space: nowrap;
      text-align: right;
      color: #1c1c25;
    }
    span {
      color: rgb(76, 132, 255);
    }
    .list-bit{
      line-height: 30px;
    }
    p{
      font-size: 20px;
    }
  }
}

.five {
  width: 60%;
  margin: auto;
  display: flex;
  justify-content:center;
  .left {
    padding-top: 20px;
    width: 500px;
    font-size: 22px;
    text-align: left;
    color: #666666;
    h2 {
      color: #1c1c25;
    }
    span {
    font-size: 22px;
      color: rgb(76, 132, 255);
    }
  }
  .right {
    margin-left: 50px;
    width: 700px;
    img {
      height: 100%;
      width: 115%;
      // height: 350px;
    }
  }
}

//   .footer{
//     background: url("../assets/last/bg/底部.png") no-repeat;
//     background-size: contain;
//     height: 550px;
//   }
</style>